import { Component } from '@angular/core'

@Component({
  selector: 'app-incentive-loader',
  template: ` <div class="spinner">
    <div class="container">
      <div class="columns">
        <div class="column">
          <div class="spinner--label mb-2"></div>
          <div class="table-container">
            <table class="table is-fullwidth is-striped">
              <tbody>
                <tr>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                </tr>
                <tr>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                </tr>
                <tr>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                </tr>
                <tr>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                </tr>
                <tr>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                </tr>
                <tr>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                </tr>
                <tr>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                </tr>
                <tr>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                </tr>
                <tr>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                </tr>
                <tr>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                  <td><div class="spinner--p"></div></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>`
})
export class IncentiveLoaderComponent {}
